<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="Dashboard" :active="true"/>
		</b-breadcrumb>
		<b-container ref="container" fluid v-if="metrics !== null" style="background-color: #fff">

	<!--
	<b-sidebar id="sidebar-1" title="Sidebar" shadow visible>
		<div class="px-3 py-2">
			<p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
			<b-img src="https://picsum.photos/500/500/?image=54" fluid thumbnail></b-img>
		</div>
	</b-sidebar>
	-->
			<b-row>
				<b-col lg="12" md="12" sm="12" xs="12" class="mt-2 mb-2">
					<collapsible-card title="Server Info" :visible=true>
						<b-row class="p-2">
							<b-col>
								<b-form-group label="Group:" label-for="group" description="Select the server group to display">
									<b-input-group v-if="groupOptions !== null">
										<b-form-select v-model="group" placeholder="Select Group" :options="groupOptions"></b-form-select>
									</b-input-group>
								</b-form-group>
							</b-col>
							<b-col cols="auto">
								<b-form-group label="Display Mode:" label-for="displayMode" description="">
									<b-form-radio-group id="display-mode" v-model="displayMode" :options="displayModeOptions" buttons button-variant="outline-primary" name="display-mode"/>
								</b-form-group>
							</b-col>
							<b-col cols="auto">
								<b-form-group label="Full:" label-for="full" description="">
									<b-button variant="primary" @click="fullScreen()"><icon name="arrows-alt"></icon></b-button>
								</b-form-group>
							</b-col>
						</b-row>
						<b-card-text style="overflow:auto; height: 440px">
						<table class="table table-striped table-hover table-bordered" v-if="displayMode === 'bar'">
							<thead>
								<tr>
									<th>Server</th>
									<th class="text-center" width="20%">CPU</th>
									<th class="text-center" width="20%">Memory</th>
									<th class="text-center" width="20%">Swap</th>
									<th class="text-center" width="20%">Disk</th>
									<th class="text-center">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in metrics" v-if="isMatchGroup(item.server)">
									<td @click="viewServerDashboard(item.server.id)">
										<span :style="'cursor:pointer; color: ' + item.server.color">{{item.server.name}}</span>
										<span v-if="isVisible(item.server)" class="float-right"><icon name="eye"></icon></span>
									</td>
									<td><b-progress :value="item.current.cpu.usage" :max="100" height="2rem" animated/></td>
									<td><b-progress :value="item.current.memory.usage" :max="100" height="2rem" animated/></td>
									<td><b-progress :value="item.current.swap.usage" :max="100" height="2rem" animated/></td>
									<td><b-progress :value="item.current.disk.usage" :max="100" height="2rem" animated/></td>
									<td>
										<b-link @click="setVisible(item.server, true)"><icon name="eye"></icon></b-link>
										<b-link @click="setVisible(item.server, false)"><icon name="eye-slash"></icon></b-link>
									</td>
								</tr>
							</tbody>
						</table>
						<table class="table table-striped table-hover table-bordered" v-if="displayMode === 'text'">
							<thead>
								<tr>
									<th>Server</th>
									<th class="text-center" width="20%" colspan="3">CPU</th>
									<th class="text-center" width="20%" colspan="3">Memory</th>
									<th class="text-center" width="20%" colspan="3">Swap</th>
									<th class="text-center" width="20%" colspan="3">Disk</th>
									<th class="text-center">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td></td>
									<td align="center">User</td>
									<td align="center">System</td>
									<td align="center">Total</td>
									<td align="center">Free</td>
									<td align="center">Used</td>
									<td align="center">Total</td>
									<td align="center">Free</td>
									<td align="center">Used</td>
									<td align="center">Total</td>
									<td align="center">Free</td>
									<td align="center">Used</td>
									<td align="center">Total</td>
									<td></td>
								</tr>
								<tr v-for="item in metrics" v-if="isMatchGroup(item.server)">
									<td @click="viewServerDashboard(item.server.id)">
										<span :style="'cursor:pointer; color: ' + item.server.color">{{item.server.name}}</span>
										<span v-if="isVisible(item.server)" class="float-right"><icon name="eye"></icon></span>
									</td>
									<td align="right">{{item.current.cpu.user | percentage}}</td>
									<td align="right">{{item.current.cpu.system | percentage}}</td>
									<td align="right">{{item.current.cpu.usage | percentage}}</td>
									<td align="right">{{item.current.memory.free | size}}</td>
									<td align="right">{{item.current.memory.used | size}} ({{item.current.memory.usage | percentage}})</td>
									<td align="right">{{item.current.memory.free + item.current.memory.used | size}}</td>
									<td align="right">{{item.current.swap.free | size}}</td>
									<td align="right">{{item.current.swap.used | size}} ({{item.current.swap.usage | percentage}})</td>
									<td align="right">{{item.current.swap.free + item.current.swap.used | size}}</td>
									<td align="right">{{item.current.disk.free | size}}</td>
									<td align="right">{{item.current.disk.used | size}} ({{item.current.disk.usage | percentage}})</td>
									<td align="right">{{item.current.disk.free + item.current.disk.used | size}}</td>
									<td>
										<b-link @click="setVisible(item.server, true)"><icon name="eye"></icon></b-link>
										<b-link @click="setVisible(item.server, false)"><icon name="eye-slash"></icon></b-link>
									</td>
								</tr>
							</tbody>
						</table>
						</b-card-text>
					</collapsible-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">CPU Trend</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="microchip" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="cpuTrendChart" :chartData="cpu.trend.chartData" :options="cpu.trend.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Memory</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="memory" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="memoryTrendChart" :chartData="memory.trend.chartData" :options="memory.trend.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Disk Activity</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="hdd" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="disksActivityTrendChart" :chartData="disks.activity.chartData" :options="disks.activity.chartOptions"></line-chart>
						</b-card-text>
						<template v-slot:footer>
							Graph going up is bytes read, graph going down is bytes written
						</template>
					</b-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Network Activity</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="network-wired"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="networkTrendChart" :chartData="network.chartData" :options="network.chartOptions"></line-chart>
						</b-card-text>
						<template v-slot:footer>
							Graph going up is bytes received, graph going down is bytes sent
						</template>
					</b-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Swap</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="memory" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="swapTrendChart" :chartData="swap.trend.chartData" :options="swap.trend.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import {HTTP} from '../../services/HttpService'
import {colorService} from '../../services/ColorService'
import DoughnutChart from '../../components/DoughnutChart.vue'
import BarChart from '../../components/BarChart.vue'
import LineChart from '../../components/LineChart.vue'
import CollapsibleCard from '../../components/CollapsibleCard.vue'

export default {
  components: {
    DoughnutChart,
    BarChart,
    LineChart,
    CollapsibleCard
  },
  name: 'dashboard',
  data: () => ({
    servers: null,
    serversMap: null,
    group: '',
    groupOptions: null,
    metrics: null,
    displayMode: 'bar',
    displayModeOptions: [
      { text: 'Text', value: 'text' },
      { text: 'Bar', value: 'bar' }
    ],
    refreshInterval: null,
    cpu: {
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#9fcdff',
            borderColor: '#9fcdff',
            data: []
          }, {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      }
    },
    memory: {
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      }
    },
    swap: {
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      }
    },
    disks: {
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      },
      activity: {
        chartData: {
          labels: [],
          datasets: []
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                suggestedMin: -5242880,
                suggestedMax: 5242880,
                callback: function (value, index, values) {
                  var max = Math.abs(value)
                  var divisor = 1
                  var suffix = ''
                  if (max > 1048576) {
                    divisor = 1048576
                    suffix = ' mb'
                  } else if (max > 1024) {
                    divisor = 1024
                    suffix = ' kb'
                  }
                  return (Math.abs(value) / divisor).toFixed(2) + suffix
                }
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }]
          }
        }
      }
    },
    network: {
      chartData: {
        labels: [],
        datasets: [ {
          label: 'Received',
          fill: true,
          backgroundColor: '#9fcdff',
          borderColor: '#9fcdff',
          data: []
        }, {
          label: 'Sent',
          fill: true,
          backgroundColor: '#f1b0b7',
          borderColor: '#f1b0b7',
          data: []
        }]
      },
      chartOptions: {
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              suggestedMin: -1048576,
              suggestedMax: 1048576,
              callback: function (value, index, values) {
                var max = Math.abs(value)
                var divisor = 1
                var suffix = ''
                if (max > 1048576) {
                  divisor = 1048576
                  suffix = ' mb'
                } else if (max > 1024) {
                  divisor = 1024
                  suffix = ' kb'
                }
                return (Math.abs(value) / divisor).toFixed(2) + suffix
              }
            },
            scaleLabel: {
              display: true,
              labelString: ''
            }
          }]
        }
      }
    }
  }),
  methods: {
    colorSeverity (color, value) {
      console.log(colorService.colorHexToRGBA(color, value / 100))
      return colorService.colorHexToRGBA(color, value / 100)
    },
    loadGroups () {
      this.groupOptions = []
      this.groupOptions.push({
        value: '',
        text: 'All'
      })
      for (var i in this.servers) {
        var server = this.servers[i]
        var indexOf = this.groupOptions.map(function (element) {
          return element.text
        }).indexOf(server.group)
        if (indexOf < 0) {
          var option = {
            value: server.group,
            text: server.group
          }
          this.groupOptions.push(option)
        }
      }
    },
    loadServers () {
      HTTP.get('servers', {
        params: {
          page: 0,
          rowsPerPage: 1000
        }
      })
      .then(response => {
        this.servers = response.data.list
        this.serversMap = []
        for (var i in this.servers) {
          var server = this.servers[i]
          server.visible = true
          this.serversMap[server.id] = server
        }
        console.log(this.serversMap)
        if (this.groupOptions === null) {
          this.loadGroups()
        }
      })
    },
    setVisible (server, visible) {
      this.serversMap[server.id].visible = visible
    },
    isMatchGroup (serverParam) {
      if (this.group === '') {
        return true
      }
      if (this.group === serverParam.group) {
        return true
      }
      return false
    },
    isVisible (serverParam) {
      var server = this.serversMap[serverParam.id]
      if (server === undefined || server === null) {
        return false
      }
      return server.visible
    },
    isServerRendered (serverParam) {
      if (this.group !== '') {
        if (this.group !== serverParam.group) {
          return false
        }
      }
      var server = this.serversMap[serverParam.id]
      if (server === undefined || server === null) {
        return false
      }
      return server.visible
    },
    updateData () {
      HTTP.get('dashboard')
        .then(response => {
          this.metrics = response.data
          this.cpu.trend.chartData.datasets = []
          this.memory.trend.chartData.datasets = []
          this.swap.trend.chartData.datasets = []
          this.disks.activity.chartData.datasets = []
          this.network.chartData.datasets = []
          for (var i in this.metrics) {
            var server = this.metrics[i]
            if (this.isServerRendered(server.server) === false) {
              continue
            }
            var labels = []
            var cpuUsageTrend = []
            var memoryUsageTrend = []
            var swapUsageTrend = []
            var diskUsageTrend = []
            var diskReadsTrend = []
            var diskWritesTrend = []
            var networkReadsTrend = []
            var networkWritesTrend = []
            for (var j in server.metrics) {
              var metric = server.metrics[j]
              labels.push('')
              cpuUsageTrend.push(metric.cpu.usage)
              memoryUsageTrend.push(metric.memory.usage)
              swapUsageTrend.push(metric.swap.usage)
              diskUsageTrend.push(metric.disk.usage)
              diskReadsTrend.push(metric.disk.reads)
              diskWritesTrend.push(-metric.disk.writes)
              networkReadsTrend.push(metric.network.receivedBytes)
              networkWritesTrend.push(-metric.network.sentBytes)
            }
            var dataset = {
              fill: true,
              backgroundColor: colorService.colorHexToRGBA(server.server.color, 0.5),
              borderColor: server.server.color,
              borderWidth: 1,
              pointRadius: 1,
              data: cpuUsageTrend
            }
            // update cpu trend data
            this.cpu.trend.chartData.labels = labels
            this.cpu.trend.chartData.datasets.push(dataset)

            // update memory trend data
            dataset = {
              fill: true,
              backgroundColor: colorService.colorHexToRGBA(server.server.color, 0.5),
              borderColor: server.server.color,
              borderWidth: 1,
              pointRadius: 1,
              data: memoryUsageTrend
            }
            this.memory.trend.chartData.labels = labels
            this.memory.trend.chartData.datasets.push(dataset)

            // update swap trend data
            this.swap.trend.chartData.labels = labels
            dataset = {
              fill: true,
              backgroundColor: colorService.colorHexToRGBA(server.server.color, 0.5),
              borderColor: server.server.color,
              borderWidth: 1,
              pointRadius: 1,
              data: swapUsageTrend
            }

            // update disk trend chart data
            // this.disks.trend.chartData.labels = labels
            // this.disks.trend.chartData.datasets[0].data = diskUsageTrend

            // update disk activity trend chart data
            this.disks.activity.chartData.labels = labels
            dataset = {
              fill: true,
              backgroundColor: colorService.colorHexToRGBA(server.server.color, 0.5),
              borderColor: server.server.color,
              borderWidth: 1,
              pointRadius: 1,
              data: diskReadsTrend
            }
            this.disks.activity.chartData.datasets.push(dataset)
            dataset = {
              fill: true,
              backgroundColor: colorService.colorHexToRGBA(server.server.color, 0.5),
              borderColor: server.server.color,
              borderWidth: 1,
              pointRadius: 1,
              data: diskWritesTrend
            }
            this.disks.activity.chartData.datasets.push(dataset)

            // update network trend chart data
            this.network.chartData.labels = labels
            dataset = {
              fill: true,
              backgroundColor: colorService.colorHexToRGBA(server.server.color, 0.5),
              borderColor: server.server.color,
              borderWidth: 1,
              pointRadius: 1,
              data: networkReadsTrend
            }
            this.network.chartData.datasets.push(dataset)
            dataset = {
              fill: true,
              backgroundColor: colorService.colorHexToRGBA(server.server.color, 0.5),
              borderColor: server.server.color,
              borderWidth: 1,
              pointRadius: 1,
              data: networkWritesTrend
            }
            this.network.chartData.datasets.push(dataset)
          }
          this.$refs.cpuTrendChart.updateChart()
          this.$refs.memoryTrendChart.updateChart()
          this.$refs.swapTrendChart.updateChart()
          this.$refs.disksActivityTrendChart.updateChart()
          this.$refs.networkTrendChart.updateChart()
        })
    },
    viewServerDashboard (serverId) {
      this.$router.push({
        name: 'ServerDashboardPage',
        params: {
          serverId: serverId
        }
      })
    },
    fullScreen () {
      this.$refs.container.webkitRequestFullscreen()
    }
  },
  created () {
    this.loadServers()
    this.updateData()
    this.refreshInterval = setInterval(this.updateData, 1000)
  },
  destroyed () {
    clearInterval(this.refreshInterval)
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// DashboardPage.vue?7feacd56